import enLang from './entries/en-US'
import bnLang from './entries/bn-BD'

const AppLocale = {
	en: enLang,
	bn: bnLang
}

export default AppLocale
